import { FieldTogglerIndicator, FieldTogglerInput, FieldTogglerLabel, FieldTogglerWrapper } from './FieldToggler.styles'

interface FieldTogglerProps {
  defaultValue: boolean
  onChange: (defaultValue: boolean) => void
  label?: string
  disabled?: boolean
}

const FieldToggler = ({ defaultValue, onChange, label, disabled }: FieldTogglerProps) => {
  return (
    <FieldTogglerWrapper>
      <FieldTogglerInput
        type="checkbox"
        checked={defaultValue}
        onChange={() => onChange(!defaultValue)}
        disabled={disabled}
        id="custom-checkbox"
      />
      <FieldTogglerLabel htmlFor="custom-checkbox">
        <FieldTogglerIndicator active={defaultValue}></FieldTogglerIndicator>
        {label && <span>{label}</span>}
      </FieldTogglerLabel>
    </FieldTogglerWrapper>
  )
}

export default FieldToggler
